export interface ThumbnailImageSchemeInit {
  url: string;
}

export class ThumbnailImageScheme {
  public readonly url: string;

  constructor(init: ThumbnailImageSchemeInit) {
    this.url = init.url;
  }
}

export interface ThumbnailImageInit {
  original: ThumbnailImageScheme;
  square: ThumbnailImageScheme;
  c800x420: ThumbnailImageScheme;
  p800x600: ThumbnailImageScheme;
  w1280: ThumbnailImageScheme;
}

export default class ThumbnailImage {
  public readonly original: ThumbnailImageScheme;
  public readonly square: ThumbnailImageScheme;
  public readonly c800x420: ThumbnailImageScheme;
  public readonly p800x600: ThumbnailImageScheme;
  public readonly w1280: ThumbnailImageScheme;

  constructor(init: ThumbnailImageInit) {
    this.original = init.original;
    this.square = init.square;
    this.c800x420 = init.c800x420;
    this.p800x600 = init.p800x600;
    this.w1280 = init.w1280;
  }
}
